import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StateStorageService } from 'app/core/auth/state-storage.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthServerProvider } from '../../core/auth/auth-jwt.service';

/**
 * Http Interceptor on expired user authentication
 */
@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  private static readonly NOT_AUTH = 401;
  constructor(private readonly stateStorageService: StateStorageService, private readonly authService: AuthServerProvider, private readonly router: Router) { }

  /**
   * Intercept Error Response Request and logout user if request status is 401
   * @param request the http request
   * @param next used for binding to http request stream
   */
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (err.status === AuthExpiredInterceptor.NOT_AUTH && err.url && !err.url.includes('api/account')) {
            this.stateStorageService.storeUrl(this.router.routerState.snapshot.url);
            this.authService.logout().subscribe();
          }
        },
      })
    );
  }
}
